"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/*
 * Copyright 2026, Polytechnique Montreal and contributors
 *
 * This file is licensed under the MIT License.
 * License text available at https://opensource.org/licenses/MIT
 */
const react_1 = __importDefault(require("react"));
const react_router_1 = require("react-router");
/**
 * Root layout component for admin survey routes.
 * This component wraps all routes and provides a consistent layout structure.
 */
const AdminRootLayout = () => react_1.default.createElement(react_router_1.Outlet, null);
exports.default = AdminRootLayout;
//# sourceMappingURL=AdminRootLayout.js.map